module.exports = __webpack_public_path__ + "static/media/telegram-background.39e8c04e.svg";